import { createClient } from 'react-fetching-library';

global.Buffer = global.Buffer || require('buffer').Buffer
export const Client = createClient();